import type { ReactNode } from 'react';
import heroImage from '@/assets/login-hero.webp';
import { CoverageIllustration } from './CoverageIllustration';
import { Logo } from './Logo';

/** Split-screen layout for login and invitation pages: the 1QA hero (Figma) over the coverage map, and the form. */
export function AuthLayout({ children }: { children: ReactNode }) {
  return (
    <div className="grid min-h-dvh bg-background lg:grid-cols-2">
      {/* Always dark, like the hero image (Figma UI kit, Feature Card, node 1:1997). */}
      <div className="dark relative hidden flex-col overflow-hidden bg-background lg:flex">
        <div className="relative min-h-40 flex-1 overflow-hidden">
          <img src={heroImage} alt="1QA - Know before you go live." className="absolute inset-0 size-full animate-hero-drift object-cover object-center" />
          <div className="pointer-events-none absolute inset-x-0 h-px animate-scan bg-gradient-to-r from-transparent via-primary/70 to-transparent" aria-hidden />
          <div className="pointer-events-none absolute inset-x-0 bottom-0 h-32 bg-gradient-to-t from-background to-transparent" aria-hidden />
        </div>
        <div className="relative mx-auto w-full max-w-xl px-12 pb-10">
          <CoverageIllustration />
          <p className="mt-5 text-xs text-fg-muted">One place for web, mobile, API, performance, security and LLM testing - written in plain English.</p>
        </div>
      </div>
      <div className="flex items-center justify-center px-6 py-12">
        <div className="w-full max-w-sm animate-slide-up">
          <div className="mb-10">
            <Logo />
          </div>
          {children}
        </div>
      </div>
    </div>
  );
}
